import FormData from "form-data";
import { baseService } from "service/base";
import { features } from "ui/features";

class DeviceService {
  load() {
    return baseService.get("/api/devices/lite", { page: "all" });
  }

  loadDeleted() {
    return baseService.get("/api/devices/lite/deleted", { page: "all" });
  }

  updateStatuses() {
    // TODO(jhohman): deprecated once websockets fully deployed.
    return baseService.get("/api/devices/status");
  }

  // eslint-disable-next-line max-params
  register(
    code,
    name,
    networkId,
    tags,
    partnerVenueId,
    location,
    isAgent = false,
  ) {
    const data = {
      code,
      isAgent,
      name,
      tags,
      networkId,
    };

    if (partnerVenueId) {
      data.partnerVenueId = partnerVenueId;
    }

    if (location) {
      data.location = location;
    }

    return baseService.post("/api/device", data);
  }

  bulkRegister(file, sid = null) {
    const data = new FormData();
    data.append("file", file);
    if (sid) {
      data.append("sid", sid);
    }

    return baseService.post("/api/devices/bulk-register", data, "form");
  }

  bulkEdit(file, sid = null) {
    const data = new FormData();
    data.append("file", file);
    if (sid) {
      data.append("sid", sid);
    }

    return baseService.put("/api/devices/bulk-edit", data, "form");
  }

  bulkCustomDownload(appParams, flags, properties, targets) {
    const apiVer = features.APP_PARAMETERS_V3 ? "v2/" : "";
    const url = `/api/devices/${apiVer}bulk-download`;
    return baseService.post(url, {
      appParams,
      flags,
      properties,
      targets,
    });
  }

  bulkDownload() {
    const apiVer = features.APP_PARAMETERS_V3 ? "v2/" : "";
    const url = `/api/devices/${apiVer}bulk-download`;
    return baseService.get(url);
  }

  clearCache(deviceId) {
    return baseService.get(`/api/device/${deviceId}/clear-cache`);
  }

  clearWebcamSnapshotCache(deviceId) {
    return baseService.get(`/api/device/${deviceId}/clear-webcam-snapshot-cache`);
  }

  genConfig(strategyId, targetIds) {
    return baseService.post("/api/devices/gen-config", {
      strategyId: strategyId,
      targetIds: targetIds,
    });
  }

  getPlayerUpdateVersions() {
    return baseService.get(`/api/devices/player_version_updates`);
  }

  uploadConfig(file) {
    let data = new FormData();
    data.append("file", file);
    return baseService.put("/api/devices/gen-config", data, "form");
  }

  upgrade(args) {
    if (Array.isArray(args)) {
      return baseService.put("/api/devices/upgrade", { deviceIds: args });
    }
    return baseService.put("/api/devices/upgrade", args);
  }

  upgradeFirmware(ids) {
    return baseService.put("/api/devices/upgrade-firmware", { deviceIds: ids });
  }

  downgrade(args) {
    if (Array.isArray(args)) {
      return baseService.put("/api/devices/downgrade", { deviceIds: args });
    }
    return baseService.put("/api/devices/downgrade", args);
  }

  cancelUpgrade(ids) {
    if (Array.isArray(ids)) {
      return baseService.delete("/api/devices/upgrade", { deviceIds: ids });
    }
    return baseService.delete("/api/devices/upgrade", ids);
  }

  delete(ids) {
    return baseService.delete("/api/devices", { deviceIds: ids });
  }

  updateParams(deviceId, params) {
    const apiVer = features.APP_PARAMETERS_V3 ? "v2/" : "";
    const url = `/api/device/${apiVer}${deviceId}/params`;

    return baseService.put(url, { params: params });
  }

  updateFlags(deviceId, flags) {
    return baseService.put(`/api/device/${deviceId}/flags`, { flags: flags });
  }

  // eslint-disable-next-line max-params
  edit(id, name, networkId, testing, location, tags, operateParams) {
    return baseService.put(`/api/device/${id}`, {
      name,
      networkId,
      testing,
      location,
      tags,
      operateParams,
    });
  }

  takeScreenshot(deviceId) {
    return baseService.get(`/api/device/${deviceId}/screenshot`);
  }

  takeSnapshot(deviceId) {
    return baseService.get(`/api/device/${deviceId}/snapshot`);
  }

  getInternalState(deviceId) {
    return baseService.get(`/api/device/${deviceId}/internal-state`);
  }

  getLogs(deviceId, level, start, end) {
    return baseService.get(
      `/api/device/${deviceId}/logs/${level}/${start}/${end}`,
    );
  }

  getSchedule(deviceId) {
    return baseService.get(`/api/device/${deviceId}/schedule`);
  }

  restartDevice(deviceId) {
    return baseService.get(`/api/device/${deviceId}/restart`);
  }
}

const deviceService = new DeviceService();

export { deviceService, DeviceService };
